module.exports = __webpack_public_path__ + "img/linkedin_logo.30c453b7.png";